import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import dayjs from 'dayjs';
import axios from 'axios';
import {
    Button,
    Input,
    Card,
    Form,
    Typography,
    Space,
    Modal,
    Checkbox,
    DatePicker,
    message,
    InputNumber,
    Popconfirm,
    Select,
    Col,
    Row,
    Table,
} from 'antd';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
const pageKey = 'BookHplTaskList'; //页面身份
export default function BookHplTaskList() {
    const [dataSource, setData] = useState([]);
    const [deVal, setDeVal] = useState([]);
    // const [pageKey, setPageKey] = useState(pageKey);
    const [form] = Form.useForm();
    const [newForm] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [pageSize, setSize] = useState([]);
    const [total, setTol] = useState([]);
    const [current, setPage] = useState([]);
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formSearch] = Form.useForm();
    const [promptText, setPromptText] = useState([]);
    const [hostOptions, setOptions] = useState([]);
    const [submittingIds, setSubmittingIds] = useState(new Set()); // 记录正在提交的ID

    const loading = () => {
        ajax.get('/hpl/book/task')
            .then((response) => {
                let data = response.data;
                setTol(response.pagination.total);
                const newRes = response.data.map((item) => {
                    create(item);
                    return item;
                });
                setData(newRes);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        // loading();
        renderSearch({ current: 1 });
    }, []);
    const csh = (row) => {
        if (row.is_order === '开启') {
            row.is_order = 1;
        } else if (row.is_order === '关闭') {
            row.is_order = 0;
        }
    };
    const create = (item) => {
        if (item.is_order == 0) {
            item.is_order = '关闭';
        } else if (item.is_order == 1) {
            item.is_order = '开启';
        }
    };
    const save = async (id) => {
        try {
            const row = await form.validateFields();
            csh(row);
            let params = {
                ...row,
                id: id,
            };

            ajax.post('/hpl/book/task', params)
                .then((response) => {
                    message.success(response);
                    loading();
                })
                .catch((err) => {
                    console.log(err);
                });
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const EditableCell = ({
        editing,
        inputType,
        dataIndex,
        title,
        inputTypeBox,
        inputTypeStart,
        inputTypeEnd,
        openTypeSelect,
        record,
        index,
        children,
        inputTypeDate,
        ...restProps
    }) => {
        let inputNode;
        if (inputType === 'number') {
            inputNode = <InputNumber />;
        } else {
            inputNode = <Input />;
        }
        if (openTypeSelect === 'select') {
            inputNode = <Select style={{ width: 80 }} options={createJsonOptions(['开启', '关闭'])} showSearch allowClear></Select>;
        }

        if (inputTypeBox === 'select') {
            inputNode = (
                <Select
                    style={{ width: 100 }}
                    options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                    showSearch
                    allowClear
                ></Select>
            );
        }
        if (inputTypeStart === 'select') {
            inputNode = <Select style={{ width: 180 }} options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>;
        }
        if (inputTypeEnd === 'select') {
            inputNode = <Select style={{ width: 180 }} options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>;
        }
        if (inputTypeDate === 'date') {
            inputNode = (
                <Space direction="vertical">
                    <DatePicker style={{ width: 100 }} defaultValue={deVal} onChange={onChange} format="YYYY-MM-DD" />
                </Space>
            );
        }

        return (
            <td>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const isEditing = (record) => record.id === editingKey;

    const onChange = (val) => {
        form.setFieldsValue({
            order_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    const edit = (record) => {
        setDeVal(dayjs(record.order_date));
        form.setFieldsValue({
            id: record.id,
            order_id: record.order_id,
            account_name: record.account_name,
            box_type: record.box_type,
            origincity_name: record.origincity_name,
            destinationcity_name: record.destinationcity_name,
            order_date: record.order_date,
            is_order: record.is_order,
            quantity: record.quantity,
            ...record,
        });
        setEditingKey(record.id);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '对应taskID',
            dataIndex: 'order_id',
            editable: true,
            sorter: (a, b) => a?.order_id - b?.order_id,
        },
        {
            title: '账户名',
            dataIndex: 'account_name',
            editable: true,
            sorter: (a, b) => a['account_name'].localeCompare(b['account_name']),
        },
        {
            title: '数量',
            dataIndex: 'quantity',
            editable: true,
            sorter: (a, b) => a?.quantity - b?.quantity,
        },
        {
            title: '重量',
            dataIndex: 'weight',
            editable: true,
            sorter: (a, b) => a?.weight - b?.weight,
        },
        {
            title: '箱型',
            dataIndex: 'box_type',
            editable: true,
            sorter: (a, b) => a['box_type'].localeCompare(b['box_type']),
        },
        {
            title: '起始港',
            dataIndex: 'origincity_name',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['origincity_name'].localeCompare(b['origincity_name']),
        },
        {
            title: '目的港',
            dataIndex: 'destinationcity_name',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['destinationcity_name'].localeCompare(b['destinationcity_name']),
        },
        {
            title: '搜索开航日',
            dataIndex: 'order_date',
            // width: 150,
            editable: true,
            sorter: (a, b) => a['order_date'].localeCompare(b['order_date']),
        },
        {
            title: '品名',
            dataIndex: 'cargo_description',
            editable: true,
            sorter: (a, b) => a['cargo_description'].localeCompare(b['cargo_description']),
        },
        {
            title: '是否开启',
            dataIndex: 'is_order',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['is_order'].localeCompare(b['is_order']),
        },
        {
            title: '提交',
            width: 80,
            dataIndex: 'operation',
            render: (_, record) => {
                const isSubmitting = submittingIds.has(record.id);
                return dataSource.length >= 1 ? (
                    <Button onClick={() => sub(record)} loading={isSubmitting} disabled={isSubmitting}>
                        {isSubmitting ? '提交中' : '提交'}
                    </Button>
                ) : null;
            },
        },
        {
            title: '操作',
            // width: 120,
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            保存
                        </Typography.Link>
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        修改
                    </Typography.Link>
                );
            },
        },
    ];

    const renderSearch = ({ current, pageSize }) => {
        setSelectedRowKeys([]);
        let params = formSearch.getFieldsValue();
        params.per_page = pageSize;
        setSize(pageSize);
        setPage(current);
        params.page = current;
        ajax.get('/hpl/book/task', { params })
            .then((response) => {
                if (response.data) {
                    response.data.map((item) => {
                        create(item);
                        return item;
                    });
                    setData(response.data);
                    setTol(response.pagination.total);
                } else if (response == undefined) {
                    response = [];
                    setData(response);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                openTypeSelect: col.dataIndex === 'is_order' ? 'select' : 'text',
                inputTypeBox: col.dataIndex === 'box_type' ? 'select' : 'text',
                inputTypeStart: col.dataIndex === 'origincity_name' ? 'select' : 'text',
                inputTypeEnd: col.dataIndex === 'destinationcity_name' ? 'select' : 'text',
                inputTypeDate: col.dataIndex === 'order_date' ? 'date' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    // 获取多选的id
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // 多选
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 50,
    };

    const onMenuClick = () => {
        if (selectedRowKeys.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error('请选择要修改的数据');
        }
    };

    const handleOk = () => {
        // setIsModalOpen(false);
        const prm = newForm.getFieldsValue();
        if (prm.is_order === '开启') {
            prm.is_order = 1;
        } else if (prm.is_order === '关闭') {
            prm.is_order = 0;
        }

        prm.ids = selectedRowKeys.toString().replaceAll(',', ', ');

        // 批量修改
        ajax.post('/hpl/group/task', prm)
            .then((response) => {
                message.success('修改成功');
                newForm.resetFields();
                setSelectedRowKeys([]);
                setIsModalOpen(false);
                loading();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleCancel = () => {
        newForm.resetFields();
        setSelectedRowKeys([]);
        setIsModalOpen(false);
    };

    const onShowSizeChange = (row) => {
        renderSearch(row);
    };

    const newOnChange = (val) => {
        newForm.setFieldsValue({
            order_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    // 提交
    const sub = (record) => {
        // 如果正在提交，直接返回
        if (submittingIds.has(record.id)) {
            return;
        }

        // 设置提交状态
        setSubmittingIds((prev) => new Set(prev).add(record.id));

        // 去掉不需要的属性
        const { id, order_id, is_order, ...filteredRecord } = record;

        const customAxios = axios.create({
            baseURL: '', // 使用相对路径，通过代理访问
        });

        // 使用代理
        customAxios
            .get('/hpl/price', {
                params: filteredRecord,
                timeout: 30000, // 设置超时
            })
            .then((response) => {
                message.success(response.data);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                // 清除提交状态
                setSubmittingIds((prev) => {
                    const newSet = new Set(prev);
                    newSet.delete(record.id);
                    return newSet;
                });
            });
    };

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <PageHeader title="HplTask列表" sticky></PageHeader>

                    <Col style={{ width: '15%', display: 'flex', justifyContent: 'space-around' }}>
                        <Button type="primary" onClick={() => onMenuClick()}>
                            批量修改
                        </Button>
                    </Col>
                </div>
            </div>
            <Card style={{ width: '100%' }} className="ax-search-card">
                <Form form={formSearch} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col style={{ width: '13%' }}>
                            <Form.Item label="对应taskID" name="order_id">
                                <Input style={{ width: '80%' }}></Input>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '17%' }}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '17%' }}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ display: 'flex', width: '30%' }}>
                            <Form.Item style={{ width: '50%', marginRight: '5%' }} label="箱型" name="box_type">
                                <Select
                                    options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                            <span style={{ width: '40%', marginLeft: '10%' }}>
                                <Button onClick={() => renderSearch({ current: 1 })} type="primary">
                                    搜索
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Modal title="" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} closable={false}>
                <Form form={newForm} style={{ width: '80%', margin: '0 auto' }}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="对应taskID" name="order_id">
                                <Input />
                            </Form.Item>
                        </Col>
                        {/* <Col span={24}>
                            <Form.Item label="添加taskID" name="order_id_add">
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col span={24}>
                            <Form.Item label="账户" name="account_name">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="数量" name="quantity">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="重量" name="weight">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Form.Item label="箱型" name="box_type">
                                    <Select
                                        style={{ width: 140 }}
                                        options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                        showSearch
                                        allowClear
                                    ></Select>
                                </Form.Item>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="搜索开航日" name="order_date">
                                <Space direction="vertical">
                                    <DatePicker onChange={newOnChange} format="YYYY-MM-DD" />
                                </Space>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select style={{ width: 320 }} options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select style={{ width: 320 }} options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="是否开启" name="is_order">
                                <Select style={{ width: 100 }} options={createJsonOptions(['开启', '关闭'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        {/* <Col span={12}>
                            <Form.Item label="是否重复添加" name="is_add_data">
                                <Select style={{ width: 100 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col> */}
                    </Row>
                </Form>
            </Modal>

            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    rowSelection={rowSelection}
                    rowKey={(record) => record.id}
                    bordered
                    dataSource={dataSource}
                    // virtual
                    // columns={mergedColumns}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        current: current,
                        pageSizeOptions: [100, 200, 500, 1000],
                    }}
                    onChange={onShowSizeChange}
                />
            </Form>
        </div>
    );
}
